import React from "react";
import { Route, Switch } from "react-router-dom";
import Loadable from 'react-loadable';

import CircularProgress from "components/CircularProgress";
import Error404 from "../../components/ErrorPages/Error404";

const Dashboard = Loadable({
  loader: () => import('../../containers/Admin/Dashboard'),
  loading: CircularProgress,
});
const Master = Loadable({
  loader: () => import("./Master"),
  loading: CircularProgress,
});
const Reports = Loadable({
  loader: () => import('../../containers/Admin/Reports/index'),
  loading: CircularProgress,
});
const HL7ReceivedMessages = Loadable({
  loader: () => import('../../containers/Admin/HL7ReceivedMessages/index'),
  loading: CircularProgress,
});
const HL7SentMessages = Loadable({
  loader: () => import('../../containers/Admin/HL7SentMessages'),
  loading: CircularProgress,
});
const LoggedInUsers = Loadable({
  loader: () => import('../../containers/Admin/LoggedInUsers'),
  loading: CircularProgress,
});
const LockedVisits = Loadable({
  loader: () => import('../../containers/Admin/LockedVisits/index'),
  loading: CircularProgress,
});
const SearchVisit = Loadable({
  loader: () => import('../../containers/SearchVisit/index'),
  loading: CircularProgress,
});
const VisitReportViewer = Loadable({
  loader: () => import('../../containers/SearchVisit/ReportViewer/index'),
  loading: CircularProgress,
});
const HL7Queue = Loadable({
  loader: () => import('../../containers/Admin/HL7Queue'),
  loading: CircularProgress,
});

const Admin = ({ match }) => (
  <Switch>
    <Route path={`${match.url}/dashboard`} component={Dashboard} />
    <Route path={`${match.url}/master`} component={Master} />
    <Route exact path={`${match.url}/reports`} component={Reports} />
    <Route path={`${match.url}/hl7-received-messages`} component={HL7ReceivedMessages} />
    <Route path={`${match.url}/hl7-sent-messages`} component={HL7SentMessages} />
    <Route path={`${match.url}/logged-in-users`} component={LoggedInUsers} />
    <Route path={`${match.url}/locked-visits`} component={LockedVisits} />
    <Route path={`${match.url}/search-visit`} component={SearchVisit} />
    <Route path={`${match.url}/visit-report-viewer`} component={VisitReportViewer} />
    <Route path={`${match.url}/hl7-queue-messages`} component={HL7Queue} />
    <Route component={() => <Error404 redirectTo="/admin/dashboard" />} />
  </Switch>
);

export default Admin;
